import styled, { css } from "styled-components";
import SETooltip from "@streeteasy/design-system/legacy/Tooltip";

import { largeScreen, smallScreen } from "src/shared/constants/screenSizes";

export const Tooltip = styled(SETooltip)`
  display: flex;
  margin-left: 10px;
  text-transform: none;

  @media screen and (min-width: ${largeScreen}px) {
    text-transform: none;
    ${({ $hasDrawerForm }) =>
      $hasDrawerForm ? `display: inline-flex;` : `margin-left: 5px;`}
  }

  ${({ inModalHeader }) =>
    inModalHeader &&
    css`
      display: block;
      position: absolute;
      right: -15px;
      top: 0;

      i {
        color: white;
      }

      @media screen and (min-width: ${smallScreen}px) {
        right: -30px;
      }
    `};
`;
